import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { getProperty } from 'dot-prop';
import { componentNameForCdnComponent } from "../../const";
import { parseJsonProps, loadScript, loadStyle } from "../../utils";

/**
 * material 测试资源
 * https://mui.com/material-ui/react-slider/
https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap
https://fonts.googleapis.com/icon?family=Material+Icons
https://g.alipay.com/@mui/material@5.11.8/umd/material-ui.production.min.js
 */

export default function View(props) {
  var _context = props._context,
    urls = props.urls,
    componentPath = props.componentPath,
    _jsonProps = props._jsonProps;
  var _useState = useState(true),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState(false),
    failLoad = _useState2[0],
    setFailLoad = _useState2[1];
  useEffect(function () {
    function go() {
      return _go.apply(this, arguments);
    }
    function _go() {
      _go = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!urls || !componentPath)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.next = 4;
              return Promise.all(urls.map( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
                  var type, url;
                  return _regeneratorRuntime.wrap(function _callee$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (item) {
                          _context2.next = 2;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 2:
                        type = item.type, url = item.url;
                        if (!(!type || !url)) {
                          _context2.next = 5;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 5:
                        if (!(type === 'style')) {
                          _context2.next = 10;
                          break;
                        }
                        _context2.next = 8;
                        return loadStyle(url);
                      case 8:
                        _context2.next = 13;
                        break;
                      case 10:
                        if (!(type === 'script')) {
                          _context2.next = 13;
                          break;
                        }
                        _context2.next = 13;
                        return loadScript(url);
                      case 13:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee2);
      }));
      return _go.apply(this, arguments);
    }
    go()["catch"](function () {
      setFailLoad(true);
    })["finally"](function () {
      setLoading(false);
    });
  }, [urls, componentPath]);
  if (!componentPath) return null;
  if (failLoad) {
    return /*#__PURE__*/React.createElement("div", {
      className: "cn-lowcode-page-cdn-component-failed-to-load-" + componentPath
    });
  }
  if (loading) return /*#__PURE__*/React.createElement("div", {
    className: "cn-lowcode-page-cdn-component-loading"
  });
  var Comp = getProperty(window, componentPath);
  if (!Comp) return null;
  var compProps = parseJsonProps({
    _context: _context,
    _jsonProps: _jsonProps
  });
  return /*#__PURE__*/React.createElement(Comp, compProps);
}
View.displayName = componentNameForCdnComponent;